module.exports = __webpack_public_path__ + "img/consultoria2_4-3_3072.64f6ee17.jpg";